import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

import moment from 'moment';

export default {
	postSearchSelectList: param => {
		return client
			.get(`${BASE_URL}/comm/common/custCode/v1/pcRsNumCustCodeLists`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	// custom 코드조회
	async getCommCodeDetails(codeType) {
		try {
			const params = { commCdType: codeType, sqlId: 'customPrCorSql', commCd: '', refCd: '' };
			const queryString =
				'?' +
				Object.entries(params)
					.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
					.filter(r => r)
					.join('&');

			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/custCodeLists` + queryString);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getSaleList: ({ searchParams }) => {
		let queryStr = '';
		let stdYy = searchParams.searchDate;
		let rsScn = searchParams.rsScn; //지수구분
		if (searchParams.searchDate !== undefined) {
			queryStr = objectToQuerystring({
				carScn: searchParams.carScn, //차량구분
				pacScn: searchParams.pacScn, //승상구분
				// customPrCor: searchParams.customPrCor, //생산법인
				// plntCd: searchParams.plntCd, //생산공장
				flclSpc: searchParams.flclSpc, //연료전지사양
				// saleNat: searchParams.saleNat, //판매국가
				occuRegn: searchParams.occuRegn, //판매지역
				carTypeNm: searchParams.carTypeNm, //차종유형
				clmType: searchParams.clmType //클레입타입
			});
		}
		//console.log('queryStr>>>>>>>>>>>>>>>', queryStr);
		return client
			.get(`${BASE_URL}/mqy/clma/pcRsNum/v1/pcRsNums/rsScn/${rsScn}/stdYy/${stdYy}` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
